import {FC, useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import { useNavigate } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import { UploadEOBsResponse } from "./types";


const UploadEOBs: FC = (): JSX.Element => {


  const [uploadFile, changeUploadFile] = useState<FileList | null>(null);
  const navigate = useNavigate();
  const ref = useRef<HTMLInputElement>(null);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);




  const { loading: isFileUploading, error: uploadEOBsError, data: uploadEOBsData, mutate: uploadEOBsSubmit } =
    useFetch<UploadEOBsResponse>(APIEndpoints.EOBs_Upload);

  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (uploadEOBsData || uploadEOBsError) {
      hideLoader()
      if (uploadEOBsData) {
        showToast([`EOB uploaded successfully.`], ToastTypes.SUCCESS);
        clearDataAndForm()
        navigate('/explanationOfBenefit');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadEOBsData, uploadEOBsError]);

  const uploadFileData = () => {
    if (uploadFile) {
      const formData = new FormData();
      formData.append("eob_document", uploadFile[0]);
      formData.append("active", "false");
      setLoader();
      uploadEOBsSubmit(formData);
    }
  };





  const reset = () => {
    if (ref && ref.current) {
      ref.current.value = ""
    }
  };

  const clearDataAndForm = () => {
    changeUploadFile(null);
    reset();
  };





  return (
    <div className="container-fluid d-flex flex-fill auth-page body-bg overflow-auto">
      <div className="container d-flex flex-column">
        <AuthSubHeader />
        <div className="flex-fill">
          <div className="card mt-4">
            <div className="card-header">
              <h4 className="mb-0">
                Upload EOB
              </h4>
            </div>
            <div className="card-body">
              <form>
                <p>
                  {`Please select and upload an Explanation of Benefits to have our team de-identify it and add it to the library of EOBs in our EOB Warehouse. Note that it will not appear in the searchable list until the de-identification process has been completed.`} <br/> <br/>
                 {` By choosing to upload your explanation of benefits (EOB), you agree that the information provided will be available to FlexForward and other HCPs for visibility within the Provider Portal. EOBs will be redacted of all patient and Provider information, so that only Plan and benefit information is visible.`}
                </p>
                <div className="card-body">
                  <div className="input-group mb-2">
                    <input
                      type="file" className="form-control" id="fileUpload"
                      onChange={(e) => changeUploadFile(e.target.files)} ref={ref}
                    />
                    {uploadFile ? (
                      <>
                        <button
                          className="btn btn-primary" onClick={clearDataAndForm} type="button"
                          id="fileUpload" disabled={isFileUploading}
                        >
                          Clear
                        </button>

                      </>
                    ) : null}
                  </div>
                  <small className="d-block">
                    Click here to upload the patient's chart. Currently we accept .txt, .pdf, .tiff, .doc, .ccd, .cda,
                    .ccr, .ccda and image files.
                  </small>
                </div>

                {<div className="mt-3 text-end">
                  <button
                    className="btn btn-primary" type="button" name="cancel"
                    onClick={() => uploadFileData()}
                    disabled={isFileUploading}
                  >
                    <span
                      data-bs-toggle="tooltip" data-bs-placement="bottom"
                      title="This will remove the UploadEOBs Next Step from the cases screen and you will no longer be able to complete the precert below."
                    >
                      Upload
                    </span>
                  </button>
                </div>}
              </form>
            </div>
          </div>

          {/* <NewPrecertComp /> */}
        </div>
        <div className="mt-3"><FooterText footerType="black" /></div>
      </div>
    </div>
  );
};
export default UploadEOBs;
